import SettingsFooter from './SettingsFooter';

export default SettingsFooter;
